import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnrollmentReportService {

  constructor(private http: HttpClient) { }

  getAllStudentReport(orgId: number, year: number, semester: number,grade :number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlstudentsreport/${orgId}/${year}/${semester}/${grade}`);

  }

  getAllStudentReportByGroup(orgId: number, year: number, semester: number,grade :number,groupId :number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlstudentgroupsreport/${orgId}/${year}/${semester}/${grade}/${groupId}`);

  }

  generateBatchStaticticsReport(orgId: number, year: number, semester: number,grade :number,lang :string, username:string) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/generatereport100/${orgId}/${year}/${semester}/${grade}/${lang}/${username}`);

  }

  getBatchStaticticsReport(username :string) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlmatrixreport/${username}`);

  }
}
